import { render } from "./AIAgentTraining.vue?vue&type=template&id=22d5978f&scoped=true"
import script from "./AIAgentTraining.vue?vue&type=script&lang=js"
export * from "./AIAgentTraining.vue?vue&type=script&lang=js"

import "./AIAgentTraining.vue?vue&type=style&index=0&id=22d5978f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d5978f"]])

export default __exports__